module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "confirm"
  }, [_c('section', {
    staticClass: "overlay",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "c-main"
  }, [_c('i', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img
    }
  }), _vm._v(" ")])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-34f6209f!../~/vue-loader/lib/selector.js?type=template&index=0!./components/vue/confirm.vue
 ** module id = 129
 ** module chunks = 1 2
 **/